import React from "react";
const SvgSendToPhone = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      d="M14.368 18.832a.5.5 0 000 1h1.617a.5.5 0 100-1h-1.617z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M9.35 5.18c0-1.48 1.2-2.68 2.68-2.68h6.293c1.48 0 2.68 1.2 2.68 2.68v13.64c0 1.48-1.2 2.68-2.68 2.68H12.03a2.68 2.68 0 01-2.68-2.68v-2.345a.5.5 0 011 0v.733h9.653V5.18a1.68 1.68 0 00-1.68-1.68H12.03a1.68 1.68 0 00-1.68 1.68v2.365a.5.5 0 11-1 0V5.18zm1 13.64v-.612h9.653v.612a1.68 1.68 0 01-1.68 1.68H12.03a1.68 1.68 0 01-1.68-1.68z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M7.852 8.57a.5.5 0 00-.716.699l2.175 2.23H2.5a.5.5 0 000 1h6.817l-2.18 2.237a.5.5 0 10.715.698l3.006-3.082a.5.5 0 000-.699L7.852 8.572z"
    />
  </svg>
);
export default SvgSendToPhone;
